import '../../styles/Info.css'


export default function MaryChaplet() {
return(
    <div>
        <p className='info-text'>
        <p>Nossa Senhora, em sua aparição em Fátima, pediu que rezássemos o Terço todos os dias. O Terço (ou Rosário) é uma oração milenar da Igreja Católica que nos ajuda a meditar os mistérios da vida de Cristo.</p>
        <h3>Passo a passo para rezar o Terço:</h3>
        <ul className='inicio'>
            <li><strong>1 – Sinal da Cruz:</strong> Em nome do Pai, do Filho e do Espírito Santo. Amém.</li>
            <li><strong>2 – Oração de Oferecimento:</strong><br />
                "Divino Jesus, nós Vos oferecemos este terço que vamos rezar, meditando nos mistérios da nossa redenção. Concedei-nos, por intercessão da Virgem Maria, as virtudes para bem rezá-lo e a graça das indulgências desta santa devoção." (Colocar suas intenções)
            </li>
            <li><strong>3 – Credo:</strong> Segurando o crucifixo, reze o Credo:</li>
            <p>Creio em Deus Pai todo-poderoso, criador do céu e da terra; e em Jesus Cristo, seu único Filho, Nosso Senhor; que foi concebido pelo poder do Espírito Santo; nasceu na Virgem Maria, padeceu sob Pôncio Pilatos, foi crucificado morto e sepultado; desceu à mansão dos mortos; ressuscitou ao terceiro dia; subiu aos céus, está sentado à direita de Deus Pai todo-poderoso, donde há de vir a julgar os vivos e os mortos; creio no Espírito Santo, na santa Igreja Católica, na comunhão dos santos, na remissão dos pecados, na ressurreição da carne, na vida eterna. Amém                
            </p>
            <li><strong>4 – Pai-Nosso:</strong> Na primeira conta grande.</li>
            <li><strong>5 – Três Ave-Marias:</strong><br />
                - 1ª em honra a Deus Pai que nos criou.<br />
                - 2ª em honra a Deus Filho que nos remiu.<br />
                - 3ª em honra ao Espírito Santo que nos santifica.
            </li>
            <li><strong>6 – Glória ao Pai e Ó Meu Jesus:</strong><br />

                "Glória ao Pai, Ao Filho e ao Espírito Santo, como era no princípio agora e sempre, amém."<br />
                "Ó meu Jesus, perdoai-nos, livrai-nos do fogo do inferno, levai as almas todas para o céu e socorrei principalmente aquelas que mais precisarem"
            </li>
            <li><strong>7 – As dezenas:</strong> A cada dezena:<br />
                - Anuncie o Mistério do dia<br />
                - Reze 1 Pai-Nosso<br />
                - Reze 10 Ave-Marias<br />
                - Reze 1 Glória ao Pai, Ao Filho e ao Espírito Santo, como era no princípio agora e sempre, amém.
                - "Ó meu Jesus perdoai-nos, livrai-nos do fogo do inferno, e levai as almas todas para o céu, e socorrei principalmente as que mais precisarem." 
            </li>
        </ul>

        <h3>Mistérios do Terço:</h3>
        <p><strong>Mistérios Gozosos</strong> – Segunda e Sábado</p>
        <ul className='inicio'>
            <li>1. A Anunciação de São Gabriel</li>
            <li>2. A Visita de Nossa Senhora a sua prima Santa Isabel</li>
            <li>3. O Nascimento de Jesus</li>
            <li>4. A Apresentação do menino Jesus no templo</li>
            <li>5. A Perda e o encontro de Jesus no templo</li>
        </ul>

        <p><strong>Mistérios Dolorosos</strong> – Terça e Sexta</p>
        <ul className='inicio'>
            <li>1. A Agonia de Jesus no Horto</li>
            <li>2. A Flagelação</li>
            <li>3. A Coroação de espinhos</li>
            <li>4. A subida dolorosa do calvário</li>
            <li>5. A Crucifixão e morte</li>
        </ul>

        <p><strong>Mistérios Gloriosos</strong> – Quarta e Domingo</p>
        <ul className='inicio'>
            <li>1. A Ressurreição de Jesus Cristo</li>
            <li>2. A Ascensão Glorisa de Jesus Cristo</li>
            <li>3. A descida do Espírito Santo sobre os apóstolos</li>
            <li>4. A Assunção de Nossa Senhora ao Céu</li>
            <li>5. A Coroação de Nossa Senhora</li>
        </ul>

        <p>Mistérios Luminosos – Quinta-feira</p>
        <ul className='inicio'>
            <li>1. O Batismo de Jesus Cristo no Jordão</li>
            <li>2. A auto revelação de Jesus nas bodas de Caná</li>
            <li>3. A proclamação do Reino de Deus</li>
            <li>4. A Transfiguração de Jesus Cristo</li>
            <li>5. A Instituição da Eucaristia</li>
        </ul>
        <h3>Oração Final:</h3>
        <p>
        "Infinitas graças vos damos, soberana Rainha, pelos benefícios que recebemos todos os dias de vossas mãos. Dignai-vos agora e sempre tomar-nos debaixo de vosso poderoso amparo, e para mais vos louvar, vos saudamos com uma Salve-Rainha."
        </p>
        <p>Oração da Salve-Rainha:</p>
        <p>Salve, Rainha, 
        mãe de misericórdia, 
        vida, doçura, esperança nossa, salve! 
        A Vós bradamos, 
        os degredados filhos de Eva. 
        A Vós suspiramos, gemendo e chorando 
        neste vale de lágrimas. 
        Eia, pois, advogada nossa, 
        esses Vossos olhos misericordiosos 
        a nós volvei. 
        E, depois deste desterro, 
        nos mostrai Jesus, bendito fruto 
        do Vosso ventre. 
        Ó clemente, ó piedosa, 
        ó doce Virgem Maria. 
        Rogai por nós, Santa Mãe de Deus, 
        para que sejamos dignos das promessas de Cristo.</p>

        <strong>Sinal da Cruz:</strong> Em nome do Pai, do Filho e do Espírito Santo. Amém.
        </p>
        
        </div>
)}